// product/local.ts
import { z } from "zod";
var ProductStatusSchema = z.enum([
  "draft",
  "published",
  "archived",
  "backordered",
  "out_of_stock",
  "inactive"
]);
var ProductTypeFilterSchema = z.enum([
  "standard",
  "sample",
  "all"
]);

export {
  ProductStatusSchema,
  ProductTypeFilterSchema
};
